import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as call from '../../../../call';
import { IconSizes } from '../../../constants';
import ButtonComment from '../../ButtonComment';
import { UserRole } from '../../../../core';
import { toggleChat } from '../../../actions';
import { useIsWhiteboardOpen } from '../../../hooks';
const ChatControl = () => {
    const dispatch = useDispatch();
    const currentParticipant = useSelector(call.selectors.getCurrentParticipant);
    const isWhiteboardOpen = useIsWhiteboardOpen();
    const isChatAvailable = (isWhiteboardOpen && !call.helpers.isDoctor()) ||
        currentParticipant?.role === UserRole.Doctor;
    const toggleChatHandle = useCallback(() => dispatch(toggleChat()), []);
    if (!isChatAvailable) {
        return null;
    }
    return (<ButtonComment size={IconSizes.Medium} hasMarker={false} disabled={false} clickHandle={toggleChatHandle}/>);
};
export const ChatControlKey = 'chat-control';
export default ChatControl;
